import { render, staticRenderFns } from "./GeoChartKSA.vue?vue&type=template&id=2e668cbc&scoped=true"
import script from "./GeoChartKSA.vue?vue&type=script&lang=js"
export * from "./GeoChartKSA.vue?vue&type=script&lang=js"
import style0 from "./GeoChartKSA.vue?vue&type=style&index=0&id=2e668cbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e668cbc",
  null
  
)

export default component.exports